module.exports = __webpack_public_path__ + "img/Group4_26sp_english.9011feb3.jpg";